import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\shubh\\OneDrive\\Desktop\\Documents\\MMI-FREELANCING\\NEW projects\\MMI-main\\app\\industries\\industries-client.tsx");
